import discord from "../../img/discord.png";
import email from "../../img/email.png";
import phone from "../../img/phone.png";
import styled from "styled-components";
import { Discord, Email, Telefon } from "./KontaktInfo";
import { useState } from "react";
import AnimateHeight from "react-animate-height";
import { motion } from "framer-motion";
//Style tutaj
const Background = styled.div`
  overflow-x: hidden;
  margin: 0;
  width: 100%;
  min-height: 65vh;
  height: auto;

  background-color: #798460;
  overflow: hidden;
  & > h1 {
    color: #f8ffe8;
    font-size: 8vh;
    text-align: center;
  }
`;

const Pasek = styled.div`
  width: 100%;
  height: 25vh;
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  margin-bottom: 2vh;
  @media screen and (max-width: 479px) {
    height: 15vh;
  }
`;

const Kafelka = styled.div`
  cursor: pointer;
  background-color: #2e1919;
  height: 100%;
  display: flex;
  transition: 300ms;
  width: 20vw;
  justify-content: center;
  align-items: center;
  margin: 0 1vw;
  border-radius: 2vh;
  overflow-x: hidden;

  &:hover {
    background-color: #402222;
    transform: scale(0.95);
  }
`;

const Obraz = styled.div`
  height: 12vh;
  width: ${(props) => props.long || "12vh"};
  user-select: none;
  background-image: url(${(props) => props.img || null});
  background-size: 100% 100%;
  @media screen and (max-width: 479px) {
    width: 25vw;
    & {
      height: 9vh;
      width: 9vh;
    }
  }
`;

export default function Kontakt() {
  const [height1, setHeight1] = useState(0);
  const [height2, setHeight2] = useState(0);
  const [height3, setHeight3] = useState(0);
  function otwarte(x) {
    setHeight1(0);
    setHeight2(0);
    setHeight3(0);
    if (x === 1) {
      setHeight1(height1 === 0 ? "auto" : 0);
    } else if (x === 2) {
      setHeight2(height2 === 0 ? "auto" : 0);
    } else if (x === 3) {
      setHeight3(height3 === 0 ? "auto" : 0);
    }
  }

  return (
    <Background
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1>Skontaktuj się ze mną</h1>
      <Pasek>
        <Kafelka onClick={() => otwarte(1)}>
          <Obraz img={discord} long="15vh" />
        </Kafelka>
        <Kafelka onClick={() => otwarte(2)}>
          <Obraz img={phone} />
        </Kafelka>
        <Kafelka onClick={() => otwarte(3)}>
          <Obraz img={email} />
        </Kafelka>
      </Pasek>

      <AnimateHeight
        id="Discord-controls"
        duration={500}
        height={height1} // Kontrola kontaktu do discorda
        onHeightAnimationStart={console.log("zacząłem")}
        onHeightAnimationEnd={console.log("Skończyłem")}
      >
        <Discord />
      </AnimateHeight>

      <AnimateHeight
        id="Telefon-controls"
        duration={500}
        height={height2} // Kontrola Telefonu
      >
        <Telefon />
      </AnimateHeight>

      <AnimateHeight
        id="Email-controls"
        duration={500}
        height={height3} // Kontrola Maila
      >
        <Email />
      </AnimateHeight>
    </Background>
  );
}
